import { createContext, useContext, useState } from "react";
import QuoteModal from "@/components/QuoteModal";

const QuoteContext = createContext({ openQuote: () => {} });

export const useQuote = () => useContext(QuoteContext);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <QuoteContext.Provider value={{ openQuote: () => setOpen(true) }}>
      {children}
      <QuoteModal isOpen={open} onClose={() => setOpen(false)} />
    </QuoteContext.Provider>
  );
};
